import { createApiActionType } from 'app/store/utils';
import { GET_DATA_DRIVEN_TRIGGER_CANDIDATES } from 'app/lib/types/server';

const apiType = createApiActionType('executionTrigger');

export const GET_DATA_DRIVEN_TRIGGER_CANDIDATES_ACTION_TYPE = apiType(
    GET_DATA_DRIVEN_TRIGGER_CANDIDATES
);
